import { Component } from '@angular/core';
import { FnToasterService, FnModalService, FnUtilService, FnTableConfig, FnTableMetaData, TableAction, TABLE_ACTION_TYPE } from 'foundation';
import { PosHttpService } from '../../../../services/pos.http.service';
import { Subject } from 'rxjs';
import { Queue } from '../../../../modal/entity.modal';
import { MqStatsModelComponent } from './mq-stats-model/mq-stats-model.component';

@Component({
	selector: 'app-mq-stats',
	templateUrl: './mq-stats.component.html',
	styleUrl: './mq-stats.component.scss'
})
export class MqStatsComponent {

	constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService, private fnutilservice: FnUtilService, private toaster: FnToasterService) { }
	mqArray: any[] = [];
	_selectMQ: string = '';
	showMQ = false;
	brokerVersion: string = '';
	uptime: string = '';
	memoryLimit: string = '';
	memoryUsage: string = '';
	isRefresh = false;

	ngOnInit() {
		this.loadData();
	}

	config: FnTableConfig = {
		uniqueKey: 'name',
		defaultSortKey: 'name',
		tableAction: new Subject<TableAction>(),
		hideAction: false,
		hideDelete: true,
		hideEdit: true,
		isCustomTemplate: true
	};

	rowMetaArray: FnTableMetaData[] = [
		{
			key: 'name',
			description: 'Queue Name',
			type: 'string',
			isSortable: true,
		},
		{
			key: 'maxEnqueueTime',
			description: 'Max Enq Time',
			type: 'string',
			isSortable: true,
		},
		{
			key: 'avgEnqueueTime',
			description: 'AVG Enq Time',
			type: 'string',
			isSortable: true,
		},
		{
			key: 'consumerCount',
			description: 'Consumer Count',
			type: 'number',
			isSortable: true,
		},
		{
			key: 'producerCount',
			description: 'Producer Count',
			type: 'number',
			isSortable: true,
		},
		{
			key: 'expiredCount',
			description: 'Expired Count',
			type: 'number',
			isSortable: true,
		},
		{
			key: 'pendingMsgCount',
			description: 'Pending Msg Count',
			type: 'number',
			isSortable: true,
		},
		{
			key: 'enqueueMsgCount',
			description: 'Enqueue Msg Count',
			type: 'number',
			isSortable: true,
		},
		{
			key: 'dequeuedMsgCount',
			description: 'Dequeued Msg Count',
			type: 'number',
			isSortable: true,
		}
	];

	refreshAction(row: any) {
		this.isRefresh = true;
		setTimeout(() => {
			this.isRefresh = false;
		}, 1000);
		const requestMap = {
			mq: this.selectMQ,
			queue: row.name
		}
		this.posHttpSvcs.authPost('v1/ui/resetStasticsAMQ', 'resetStasticsAMQ', requestMap).subscribe((resp: any) => {
			if (resp.isError) {
				this.toaster.error(resp.data);
				return;
			}
			this.toaster.success(resp.data);
		})
	}

	purgeMQQueue(row: any) {
		const requestMap = {
			mq: this.selectMQ,
			queue: row.name
		}
		this.posHttpSvcs.authPost('v1/ui/purgeMQQueue', 'purgeMQQueue', requestMap).subscribe((resp: any) => {
			if (resp.isError) {
				this.toaster.error(resp.data);
				return;
			}
			this.toaster.success(resp.data);
		})
	}

	infoRowAction(row: any) {
		const mqModel = this.fnModalSvcs.openCustomModal(MqStatsModelComponent, {
			data: {
				mq: this.selectMQ,
				queue: row.name
			},
			hasBackdrop: true,
			width: '1000px',
		})
	}

	mqDataArray: Queue[] = [];

	loadData() {
		this.posHttpSvcs.authGet('v1/ui/loadMQBrokerData', 'loadMQBrokerData').subscribe((resp: any) => {
			if (resp.isError) {
				this.toastr.error('Invalid loadMQBrokerData ⚠️');
				return;
			}
			this.mqArray = resp.data;
		});
	}

	get selectMQ(): string {
		return this._selectMQ;
	}

	set selectMQ(selectMQ: string) {
		this._selectMQ = selectMQ;
		this.showMQ = true
		this.loadMQData();
	}

	loadMQData() {
		this.posHttpSvcs.authPost('v1/ui/loadMQData', 'loadMQData', this.selectMQ).subscribe((resp: any) => {
			if (resp.isError) {
				this.toaster.error("Issue in fetching MQ Stats");
				return;
			}
			this.mqDataArray = resp.data.queues;
			this.refreshTableData();
			this.brokerVersion = resp.data.brokerVersion;
			this.uptime = resp.data.uptime;
			this.memoryLimit = resp.data.memoryLimit;
			this.memoryUsage = resp.data.memoryUsage;
		})
	}

	refreshTableData() {
		if (this.config.tableAction.closed) {
			this.config.tableAction = new Subject<TableAction>();
		}
		this.config.tableAction.next({
			data: this.mqDataArray,
			action: TABLE_ACTION_TYPE.REFRESH,
		});
	}

	refresh() {
		this.loadMQData();
	}

}
